import CryptoJS from 'crypto-js'
import JSEncrypt from 'jsencrypt'

class EncryptionUtils {
  constructor() {
    // 从sessionStorage恢复公钥，解决刷新后publicKey为null的问题
    this.publicKey = sessionStorage.getItem('rsa_public_key') || ''
  }

  setPublicKey(publicKey) {
    this.publicKey = publicKey
    // 缓存到sessionStorage，刷新浏览器后可立即使用
    sessionStorage.setItem('rsa_public_key', publicKey)
  }

  generateAESKey() {
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
    const randomWords = CryptoJS.lib.WordArray.random(16)
    let key = ''
    for (let i = 0; i < 16; i++) {
      const byte = (randomWords.words[i >> 2] >>> (24 - (i % 4) * 8)) & 0xff
      key += chars.charAt(byte % chars.length)
    }
    return key
  }

  aesEncrypt(data, key) {
    const keyBytes = CryptoJS.enc.Utf8.parse(key)
    const encrypted = CryptoJS.AES.encrypt(
      JSON.stringify(data),
      keyBytes,
      {
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
        iv: CryptoJS.enc.Utf8.parse('1234567890123456')
      }
    )
    return encrypted.toString()
  }

  aesDecrypt(encryptedData, key) {
    const keyBytes = CryptoJS.enc.Utf8.parse(key)
    const decrypted = CryptoJS.AES.decrypt(
      encryptedData,
      keyBytes,
      {
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
        iv: CryptoJS.enc.Utf8.parse('1234567890123456')
      }
    )
    return JSON.parse(decrypted.toString(CryptoJS.enc.Utf8))
  }

  rsaEncrypt(data) {
    const encrypt = new JSEncrypt()
    encrypt.setPublicKey(this.publicKey)
    return encrypt.encrypt(data)
  }

  generateSignature(data, key) {
    const keyBytes = CryptoJS.enc.Utf8.parse(key)
    const signature = CryptoJS.HmacSHA256(JSON.stringify(data), keyBytes)
    return CryptoJS.enc.Base64.stringify(signature)
  }

  verifySignature(data, signature, key) {
    const generatedSignature = this.generateSignature(data, key)
    return generatedSignature === signature
  }

  encryptRequest(data) {
    try {
      // 如果公钥未就绪，跳过加密，返回原始数据（兼容刷新页面后公钥尚未加载的场景）
      if (!this.publicKey) {
        console.warn('RSA公钥未就绪，跳过请求加密')
        return data
      }
      const aesKey = this.generateAESKey()
      const encryptedData = this.aesEncrypt(data, aesKey)
      const signature = this.generateSignature(data, aesKey)
      const encryptedAesKey = this.rsaEncrypt(aesKey)

      return {
        encryptedData,
        encryptedAesKey,
        signature
      }
    } catch (error) {
      console.error('加密请求数据失败:', error)
      return data
    }
  }

  decryptResponse(encryptedData, encryptedAesKey, signature, aesKey) {
    const decryptedData = this.aesDecrypt(encryptedData, aesKey)
    const isValid = this.verifySignature(decryptedData, signature, aesKey)

    if (!isValid) {
      throw new Error('签名验证失败')
    }

    return decryptedData
  }
}

export default new EncryptionUtils()
